import { ReportingShellContext } from '../../common';
import { TemplateDetailController } from './templateDetailInterface';
import { TemplateDetailAggregate } from './templateDetailModel';
import {
    TemplateDetailControllerProps,
    TemplateDetailViewProps,
} from './templateDetailProps';
import { buildTemplateItemProps } from '../item';

export function createTemplateDetailController(config: {}): TemplateDetailController {
    return {
        useProps(
            context: ReportingShellContext,
            item: TemplateDetailAggregate,
            props: TemplateDetailControllerProps
        ): TemplateDetailViewProps {
            // Transform the template aggregate to UI props using the existing factory
            const templateProps = buildTemplateItemProps(item.item);

            return {
                template: templateProps,
                config: {
                    overview: item.config.overview,
                    deliverables: {
                        label: 'Deliverables',
                        items: item.config.deliverables.map((deliverable, index) => ({
                            id: `deliverable-${index}`,
                            title: deliverable.title,
                            description: deliverable.description,
                        })),
                    },
                    process: {
                        label: 'Process',
                        items: item.config.process.map((step, index) => ({
                            id: `process-${index}`,
                            title: step.title,
                            description: step.description,
                            duration: step.duration,
                        })),
                    },
                },
                keywords: {
                    label: 'Details',
                    items: [
                        {
                            id: 'provider',
                            label: 'Provider',
                            value: {
                                kind: 'text' as const,
                                text: item.item.definition.display_name,
                            },
                        },
                        {
                            id: 'category',
                            label: 'Category',
                            value: {
                                kind: 'text' as const,
                                text: item.item.tool.category,
                            },
                        },
                        {
                            id: 'deliveryTime',
                            label: 'Delivery Time',
                            value: {
                                kind: 'text' as const,
                                text: item.config.delivery_time,
                            },
                        },
                    ],
                },
                install: {
                    label: {
                        short: 'Get',
                        full: 'Get solution',
                    },
                    button: {
                        isLoading: props.isInstalling,
                        onClick: props.onInstall,
                    },
                },
            };
        },
    };
}
